import { gql } from '@apollo/client';
// local imports
import { API_MY_LINKEDIN_STATUS } from '../config/api';

export const LINKEDIN_PROFILE_IMPORT_STATUS_QUERY = gql`
  query LinkedinProfileImportStatus {
    linkedinProfileImportStatus
    @rest(
      type: "LinkedinProfileImportStatusPayload",
      path: "${API_MY_LINKEDIN_STATUS}"
    ) {
      run_status
    }
  }
`;
